export default __webpack_public_path__ + "static/media/icon2.16ff0e20.svg";